// Derive short period tags for a measure column from its formula, so mixed-period
// tables read clearly (e.g. "Premium YTD" | "Claims QTD" | "... vs LY").
const _RE = [
  [/\bYTD\s*\(/i, 'YTD'],
  [/\bQTD\s*\(/i, 'QTD'],
  [/\bMTD\s*\(/i, 'MTD'],
  [/\bITD\s*\(/i, 'ITD'],
];

export function periodBadges(formula) {
  if (!formula) return [];
  const out = [];
  for (const [re, label] of _RE) {
    if (re.test(formula) && !out.includes(label)) out.push(label);
  }
  if (/\bPY\s*\(|\bYOY\s*\(/i.test(formula)) out.push('vs LY');
  if (/\bPP\s*\(/i.test(formula)) out.push('vs PP');
  return out;
}
